<template>
  <div class="home-wrapper singel-spa">
    <menuSlide class="menu-left" v-if="!hideMenu && !hideOperMenu" />
    <div class="content-right">
      <div v-show="loading" class="subapp-loading">...</div>
      <div class="domain-layout">
        <div id="subapp-viewport" v-if="microApp === 'qiankun'">
          <router-view></router-view>
        </div>
        <div id="subapp-iframe" v-if="microApp === 'iframe'" style="font-size: 0px;">
          <iframe
            :src="`${origin + microLink}`"
            frameborder="0"
            width="100%"
            height="100%"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
  <!-- <CS></CS> -->
</template>

<script>
import { start } from "qiankun";
import { provide, onMounted, ref } from "vue";
import { mapState, useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import menuSlide from "./components/menuSlide";
import axios from "axios";
import { trace } from './lib/trace.js'
import { showTips, getCookie, toGate, isUAT } from "@/lib/libs";
// import CS from './views/CS.vue'
const initCS = async () => {
  const YSFService = await useBehavior({
    from:'/m/cx/behavior',
    name:'YSF'
  }).catch(err => {
    console.log('err', err)
  })
  
  console.log('YSFService', YSFService)

  let env = 'web'
  window.$CS = new YSFService({
    from: env
  })
  window.$CS.show()
}
export default {
  name: "AppMain",
  components: {
    menuSlide,
    // CS
    // eslint-disable-next-line vue/no-unused-components
    // ElMessage,
  },
  data() {
    return {
      hideMenu: false,
    };
  },
  computed: {
    ...mapState(["loading", "microApp", "microLink"]),
  },
  watch: {
    $route(to, from) {
      if (to.query && to.query.hideMenu) {
        this.hideMenu = true;
      } else {
        this.hideMenu = false;
      }
    },
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const hideOperMenu = ref(false);

    // 如果url中有pg/oper/risk hideOperMenu = true
    if (window.location.href.indexOf('/pg/oper/risk') !== -1) {
      hideOperMenu.value = true
    } else {
      hideOperMenu.value = false
    }

    const changeType = (toUrl, openMode = 0) => {
      let url = "" || toUrl;
      if (toUrl === "/") {
        url = "/v/vcommon/home";
      }
      const data = { microApp: "", microLink: "" };
      if (!url) return;
      // || url.includes('vcommon')
      if (url.includes(".html") || url.includes("vhotel")) {
        data.microApp = "iframe";
      } else {
        data.microApp = "qiankun";
      }
      data.microLink = url;

      store.commit("changeMicro", data);
      if (!url.startsWith("/v/")) {
        url = "/v" + url;
      }
      if (openMode == 1) {
        window.$jump.to(url, null, true);
      } else {
        window.$jump.goLocPage(url);
      }
      // history.pushState('','', '/v'+url)
    };
    provide("changeType", changeType);

    onMounted(()=>{
      setTimeout(() => {
        initCS()
        if ($ZConfig.getVal('TM_CHAT_SWITCH')) {
          Chat()
        }
      }, 1000)

      if(!window.qiankunStarted){
        window.qiankunStarted = true
        start({
          getTemplate: (e) => {
            console.log('---load', e)
            trace.log('loadapp', { data: e })
            return e
            
          }
        })
      }
      changeType(location.pathname.replace("/v/", "/") + location.search);
      orgInit()
    });
    // 预热缓存接口
    const orgInit = async () => {
      const org = await window.useBehavior({
        from: '/m/pp/behavior',
        name: 'orgInit'
      })
      return org()
    }
    return {
      hideOperMenu,
      route,
      origin:
        process.env.NODE_ENV == "development"
          ? "https://www.z-trip.cn"
          : location.origin,
    };
  },
  mounted() {
    window.addEventListener(
      "hashchange",
      () => {
        console.log(window.location.href);
      },
      false
    );
  
    setTimeout(function(){
      // 延迟一下再跳转
      let PC_COOKIE_INFO = sessionStorage.getItem("PC_COOKIE_INFO");
      if (PC_COOKIE_INFO) {
        console.log("提示客户端已经更新!");
        showTips('网站版本临时更新，如有打扰敬请谅解')
        sessionStorage.removeItem("PC_COOKIE_INFO");
      }
      
    },3000)
    setInterval(function () {
      // console.log('sonp/user/env/status.json')
      axios
        .get("/jsonp/user/env/status.json", {
          baseURL: window.$ZConfig.getPassportUrl(),
          params: {},
          timeout: 20000,
          withCredentials: true,
        })
        .then(({ data }) => {
          console.log('env/status.json', data.data);
          if (data.code != "0" || data.data == null) {
            console.error("接口错误", data);
          } else {
            // 如果存在上次的cookie,并且不一样,则刷新'
            let ztKey = isUAT()? "zaitu-ver-uat":"zaitu-ver"
            let currentCookie = getCookie(ztKey)
            let remoteTag = data.data?.tag && data.data?.tag.replaceAll(',','-') || ''
            // console.log('currentCookie', currentCookie,currentCookie , typeof (data.data?.tag.replaceAll(',','-')))
            if( data.data && currentCookie === remoteTag){
              console.log('cookie一致不需要刷新')
            }else{
              console.error('cookie不一致需要刷新','currentCookie',currentCookie,'remoteTag', remoteTag)
              let isCookieEmpty = document.cookie.indexOf(ztKey) == -1;
              // 需要检测跟当前cookie是否一致,如果一致忽略刷新
              if (data.data?.refresh || isCookieEmpty) {
                console.error('cookie不一致需要刷新',currentCookie, 'isCookieEmpty', isCookieEmpty)
                if(isCookieEmpty){
                  console.log('cookie过期了!!',data,'isCookieEmpty', isCookieEmpty )
                }else{
                  console.log('需要刷新页面',data,'isCookieEmpty', isCookieEmpty )
                }
                sessionStorage.setItem(
                  "PC_COOKIE_INFO",
                  JSON.stringify({ tag: data.data?.tag, refresh: data.data?.refresh })
                );
                toGate()
              }else{
                console.error('cookie不一致但是不需要刷新',currentCookie, remoteTag)
              }
            }
          }
        })
        .catch((err) => {
          console.log('=========',err.message || 'user/env/status.json接口错误');
        })
        .finally(() => {
          console.log("finally");
        });

      // window.$httpUtil.instance.get('/jsonp/user/env/status.json').then(data=>{
      //   console.log('检测用户cookie信息', window.$httpUtil, data)
      //   let isNeedRefresh = data.isNeedRefresh || false
      //   // if(!isNeedRefresh){
      //   //   location.href = location.origin + '/v/gate.html'
      //   // }
      // })
    }, 60000);
  },
};
</script>

<style lang="less" scoped>
.domain-layout {
  display: flex;
  height: 100%;
  overflow-y: auto;
}
.home-wrapper {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  .menu-left {
    flex: 0 0 100px;
  }
  .content-right {
    flex: 1;
    width: 100%;
    height: 100%;
    padding: 20px;
    overflow-x: auto;
    overflow-y: visible;
  }
}
</style>
